<div class="group-snackbar">
  <div class="label">
    <span class="label__text">{{label}}</span>
    <span (click)="redirect()" class="label__link">{{'Open'}}</span>
  </div>

  <div class="action">
    <mat-icon (click)="close()" class="close-icon">close</mat-icon>
  </div>
</div>
